import { render, staticRenderFns } from "./WsInfoSection.vue?vue&type=template&id=0442c49c&"
import script from "./WsInfoSection.vue?vue&type=script&lang=js&"
export * from "./WsInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports